import { get } from '~/utils';

export enum SiteKey {
    Site = 'SITE', // 主站点
    Kms = 'KMS', // 知识库
    Api = 'API' // API
}

export const getSiteConfig = () => {
    const site = get(window.jdy_config, 'site', '');
    const kmsSite = get(window.jdy_config, 'kms_site', '');
    const apiSite = get(window.jdy_config, 'api_site', '');

    return {
        [SiteKey.Site]: site,
        [SiteKey.Kms]: kmsSite,
        [SiteKey.Api]: apiSite
    };
};
